import { makeStyles } from "components/providers/makeStyles";
import { AddEntryWidget } from "../AddEntryWidget";
import { UploadEntriesWidget } from "../UploadEntriesWidget";
import { ScanEntriesWidget } from "../../../routes/events/id/divisions/eventDivisionId/entries/ScanEntriesWidget";

const useStyles = makeStyles(theme => ({
    aside: {
        display: "flex",
        marginTop: theme.spacing(1),
        "& > button": {
            minWidth: 0,
        }
    }
}));

export const EntriesActions = ({ withNFC, eventDivisionId, isTeams, registered, alternates }) => {
    const classes = useStyles();

    return (
        <aside className={classes.aside}>
            {withNFC && <ScanEntriesWidget isTeams={isTeams} registered={registered} alternates={alternates}/>}
            <UploadEntriesWidget hasEntries={registered.length > 0} eventDivisionId={eventDivisionId} isTeams={isTeams}/>
            <AddEntryWidget eventDivisionId={eventDivisionId} isTeams={isTeams} registered={registered} alternates={alternates}/>
        </aside>
    );
};
